import { forwardRef } from 'react';

import { Instance } from '@spazious/dollhouse-three';

import Model, { ModelProps } from '../Model/index.js';

export interface DecorationProps extends ModelProps {}

export const Decoration = forwardRef<Instance, DecorationProps>(
  ({ url, context, ...restProps }, ref) => {
    return <Model ref={ref} context={context} url={url} {...restProps} />;
  }
);

export default Decoration;
